/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { zindex, font, colors, spacing, breakpoints, FadeInAnimation, SlideInAnimation, FadeOutAnimation, SlideOutAnimation, ReduceMotion, animationDurationInMS } from '@chegg-ui/theme';
import { IconButton } from '@chegg-ui/button';
import { Typography } from '@chegg-ui/typography';
import styled, { css } from 'styled-components';
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        borderRadius: theme.radius.md,
        shadow: theme.boxShadow.elevation500,
        titleMarginBottom: spacing.px16,
        buttonWidth: '50%',
        lg: {
          xlBreakpointWidth: '852px',
          lgBreakpointWidth: '552px',
          mdBreakpointWidth: '552px',
          smBreakpointWidth: '288px',
          closeButtonSize: 'medium',
          closeButtonPosition: spacing.px12,
          padding: "".concat(spacing.px64, " ").concat(spacing.px64, " ").concat(spacing.px32),
          buttonMarginTop: spacing.px32
        },
        md: {
          mdBreakpointWidth: '552px',
          smBreakpointWidth: '288px',
          closeButtonSize: 'medium',
          closeButtonPosition: spacing.px12,
          padding: "".concat(spacing.px64, " ").concat(spacing.px64, " ").concat(spacing.px32),
          buttonMarginTop: spacing.px32
        },
        sm: {
          smBreakpointWidth: '288px',
          closeButtonSize: 'xsmall',
          closeButtonPosition: spacing.px4,
          padding: spacing.px32,
          buttonMarginTop: spacing.px24
        }
      };
    },
    fanta: {
      borderRadius: '0',
      shadow: 'none',
      titleMarginBottom: spacing.px24,
      buttonWidth: 'auto',
      titleTypography: {
        size: font.size.px32,
        color: colors.dark,
        weight: font.weight.bold,
        lineHeight: font.lineHeight.sm,
        letterSpacing: 'normal'
      },
      lg: {
        xlBreakpointWidth: '48.26%',
        lgBreakpointWidth: '64.0625%',
        mdBreakpointWidth: 'calc(100% - 2rem)',
        smBreakpointWidth: '100%',
        closeButtonPosition: spacing.px8,
        buttonMarginTop: spacing.px24
      },
      md: {
        closeButtonPosition: spacing.px8
      },
      sm: {
        closeButtonSize: 'small',
        closeButtonPosition: '0',
        padding: "".concat(spacing.px64, " ").concat(spacing.px64, " ").concat(spacing.px32)
      }
    },
    prop: themeProp
  };
};
/**
 * Mixins
 *
 * */

var getTypographyMixin = function getTypographyMixin(_ref) {
  var size = _ref.size,
      color = _ref.color,
      weight = _ref.weight,
      lineHeight = _ref.lineHeight,
      letterSpacing = _ref.letterSpacing;
  return css(["", " ", " ", " ", " ", ""], size && "font-size: ".concat(size, ";"), color && "color: ".concat(color, ";"), weight && "font-weight: ".concat(weight, ";"), lineHeight && "line-height: ".concat(lineHeight, ";"), letterSpacing && "letter-spacing: ".concat(letterSpacing, ";"));
};

export var FullsizeContainer = styled.div.withConfig({
  componentId: "sc-1ia47o9-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;z-index:", ";background-color:", ";"], zindex.modal, function (props) {
  return props.hideBackgroundOverlay ? 'transparent' : 'rgba(0,0,0,0.5)';
}); // this is unfortunately necessary to work around this bug: https://bugs.chromium.org/p/chromium/issues/detail?id=521364

export var ModalCenteringContainer = styled.div.withConfig({
  componentId: "sc-1ia47o9-1"
})(["animation:", ";", " box-sizing:border-box;height:100%;"], function (props) {
  return props.closing ? css(["", ",", ""], FadeOutAnimation({
    delay: 100
  }), SlideOutAnimation({
    toX: '0',
    toY: '20px',
    duration: animationDurationInMS.medium
  })) : css(["", ",", ""], FadeInAnimation(), SlideInAnimation({
    fromX: '0',
    fromY: '20px',
    duration: animationDurationInMS.medium
  }));
}, ReduceMotion);
export var Title = styled(Typography).withConfig({
  componentId: "sc-1ia47o9-2"
})(["animation:", ";", " &&{display:block;margin:0 0 ", " 0;text-align:inherit;color:", ";", "}"], function (props) {
  return props.closing ? css(["", ",", ""], FadeOutAnimation({
    delay: 100
  }), SlideOutAnimation({
    toX: '0',
    toY: '10px',
    delay: 100
  })) : css(["", ",", ""], FadeInAnimation({
    delay: 100,
    fillMode: 'backwards'
  }), SlideInAnimation({
    fromX: '0',
    fromY: '10px',
    delay: 100
  }));
}, ReduceMotion, function (_ref2) {
  var customTheme = _ref2.customTheme;
  return customTheme.titleMarginBottom;
}, colors.grey900, function (_ref3) {
  var titleTypography = _ref3.customTheme.titleTypography;
  return titleTypography && getTypographyMixin(titleTypography);
});
export var Content = styled.div.withConfig({
  componentId: "sc-1ia47o9-3"
})(["animation:", ";", " word-wrap:break-word;", " line-height:", ";"], function (props) {
  return props.closing ? css(["", ",", ""], FadeOutAnimation({
    duration: animationDurationInMS.fastest,
    delay: 100
  }), SlideOutAnimation({
    toX: '0',
    toY: '10px',
    duration: animationDurationInMS.fastest,
    delay: 100
  })) : css(["", ",", ""], FadeInAnimation({
    delay: 100,
    fillMode: 'backwards'
  }), SlideInAnimation({
    fromX: '0',
    fromY: '10px',
    delay: 100
  }));
}, ReduceMotion, function (_ref4) {
  var contentOverflow = _ref4.contentOverflow;
  return contentOverflow ? "\n    overflow-y: auto;\n    overflow-x: hidden;\n  " : undefined;
}, font.lineHeight.lg);
export var StyledModal = styled.div.withConfig({
  componentId: "sc-1ia47o9-4"
})(["background-color:", ";font-family:", ";font-size:", ";display:flex;flex-direction:column;position:absolute;box-sizing:border-box;max-width:100%;max-height:100%;min-height:0;height:100%;top:50%;left:50%;transform:translate(-50%,-50%);border-radius:", ";box-shadow:", ";", " @media only screen and (min-width:", "){height:auto;", ";}@media only screen and (min-width:", "){", ";}@media only screen and (min-width:", "){", ";}"], colors.white, font.family["default"], font.size.px16, function (_ref5) {
  var customTheme = _ref5.customTheme;
  return customTheme.borderRadius;
}, function (_ref6) {
  var customTheme = _ref6.customTheme;
  return customTheme.shadow;
}, function (_ref7) {
  var customTheme = _ref7.customTheme,
      size = _ref7.size,
      renderFullScreenOnMobile = _ref7.renderFullScreenOnMobile,
      renderFullScreenWithMarginOnMobile = _ref7.renderFullScreenWithMarginOnMobile,
      isMobileScreen = _ref7.isMobileScreen;

  if (isMobileScreen) {
    if (renderFullScreenWithMarginOnMobile) {
      return "\n          width: calc(100% - ".concat(spacing.px24, ");\n          height: auto;\n          max-height: calc(100% - ").concat(spacing.px24, ");\n        ");
    }

    if (renderFullScreenOnMobile) {
      return "width: 100%;";
    }
  }

  return "\n      width: ".concat(customTheme[size].smBreakpointWidth, ";\n      height: auto;\n    ");
}, breakpoints.md.min, function (_ref8) {
  var customTheme = _ref8.customTheme,
      size = _ref8.size;
  return customTheme[size].mdBreakpointWidth ? "width: ".concat(customTheme[size].mdBreakpointWidth) : '';
}, breakpoints.lg.min, function (_ref9) {
  var customTheme = _ref9.customTheme,
      size = _ref9.size;
  return customTheme[size].lgBreakpointWidth ? "width: ".concat(customTheme[size].lgBreakpointWidth) : '';
}, breakpoints.xl.min, function (_ref10) {
  var customTheme = _ref10.customTheme,
      size = _ref10.size;
  return customTheme[size].xlBreakpointWidth ? "width: ".concat(customTheme[size].xlBreakpointWidth) : '';
});
export var ModalPadding = styled.div.withConfig({
  componentId: "sc-1ia47o9-5"
})(["max-height:100vh;", " padding:", ";@supports (display:grid){flex:1;max-height:none;}"], function (_ref11) {
  var rootOverflow = _ref11.rootOverflow;
  return rootOverflow ? "\n    overflow-y: auto;\n  " : undefined;
}, function (_ref12) {
  var customTheme = _ref12.customTheme,
      isMobileScreen = _ref12.isMobileScreen,
      size = _ref12.size;
  return isMobileScreen ? customTheme.sm.padding : customTheme[size].padding;
});
export var ConfirmationStyledModal = styled(StyledModal).withConfig({
  componentId: "sc-1ia47o9-6"
})(["& ", "{text-align:center;}& ", "{text-align:center;}"], Content, Title);
export var TopRightIconButton = styled(IconButton).withConfig({
  componentId: "sc-1ia47o9-7"
})(["position:absolute;top:", ";right:", ";&,&:hover,&:active{box-shadow:none;border:0;background:", ";}"], function (_ref13) {
  var customTheme = _ref13.customTheme,
      isMobileScreen = _ref13.isMobileScreen,
      modalSize = _ref13.modalSize;
  return isMobileScreen ? customTheme.sm.closeButtonPosition : customTheme[modalSize].closeButtonPosition;
}, function (_ref14) {
  var customTheme = _ref14.customTheme,
      isMobileScreen = _ref14.isMobileScreen,
      modalSize = _ref14.modalSize;
  return isMobileScreen ? customTheme.sm.closeButtonPosition : customTheme[modalSize].closeButtonPosition;
}, colors.transparent);
export var ButtonAnimationContainer = styled.div.withConfig({
  componentId: "sc-1ia47o9-8"
})(["display:flex;animation:", ";", ""], function (props) {
  return props.closing ? css(["", ",", ""], FadeOutAnimation({
    duration: animationDurationInMS.fastest
  }), SlideOutAnimation({
    toX: '0',
    toY: '10px',
    duration: animationDurationInMS.fastest
  })) : css(["", ",", ""], FadeInAnimation({
    delay: 200,
    fillMode: 'backwards'
  }), SlideInAnimation({
    fromX: '0',
    fromY: '10px',
    delay: 200
  }));
}, ReduceMotion);
export var ModalButtons = styled.div.withConfig({
  componentId: "sc-1ia47o9-9"
})(["display:inline-flex;flex-direction:", ";margin-top:", ";width:100%;", ";"], function (_ref15) {
  var alignment = _ref15.alignment;
  return alignment === 'horizontal' ? 'row-reverse' : 'column';
}, function (_ref16) {
  var customTheme = _ref16.customTheme,
      size = _ref16.size,
      isMobileScreen = _ref16.isMobileScreen;
  return isMobileScreen ? customTheme.sm.buttonMarginTop : customTheme[size].buttonMarginTop;
}, function (_ref17) {
  var alignment = _ref17.alignment,
      customTheme = _ref17.customTheme;
  return alignment === 'horizontal' ? "\n      & > button {\n        width: ".concat(customTheme.buttonWidth, ";\n      }\n      & > button:first-child {\n        margin-left: ").concat(spacing.px16, ";\n      }\n    ") : "\n      margin-right: auto;\n      & > button:last-child {\n        margin-top: ".concat(spacing.px16, ";\n      }");
});
export var ConfirmationModalButtons = styled.div.withConfig({
  componentId: "sc-1ia47o9-10"
})(["display:inline-flex;flex-direction:", ";margin-left:auto;margin-right:auto;flex-wrap:wrap;justify-content:center;& > button{margin-top:", ";}", ";"], function (_ref18) {
  var alignment = _ref18.alignment;
  return alignment === 'horizontal' ? 'row-reverse' : 'column';
}, spacing.px16, function (_ref19) {
  var alignment = _ref19.alignment;
  return alignment === 'horizontal' ? "& > button:first-child {\n      margin-left: ".concat(spacing.px16, ";\n    }") : "\n      margin-right: auto;\n      & > button:last-child {\n        margin-top: ".concat(spacing.px16, ";\n      }");
});
export var PresentationContent = styled.div.withConfig({
  componentId: "sc-1ia47o9-11"
})(["max-width:10rem;max-height:10rem;text-align:center;margin:0 auto ", ";@media (max-width:", "){max-width:5.5rem;max-height:5.5rem;margin-bottom:", ";}& > img{max-width:10rem;max-height:10rem;@media (max-width:", "){max-width:5.5rem;max-height:5.5rem;}}"], spacing.px32, breakpoints.sm.max, spacing.px24, breakpoints.sm.max);
export var NotificationBannerContainer = styled.div.withConfig({
  componentId: "sc-1ia47o9-12"
})(["border-radius:", ";overflow:hidden;flex:none;"], function (_ref20) {
  var customTheme = _ref20.customTheme;
  return customTheme.borderRadius;
});